import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import AddEditModal from './addEditModal.vue';
import { namespace } from 'vuex-class';
import LogModal from './logModal.vue';
import util from '@/utils/util';
var logModalCom = util.mountVueComponent(LogModal);
var User = namespace('user');

var WrapperListTab = function (_super) {
  __extends(WrapperListTab, _super);

  function WrapperListTab() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.searchData = _this.initSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.rowSelection = {};
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.addEditVisible = false;
    _this.rowData = {};
    _this.auditPageStatusEnum = [];
    _this.packageOptionEnum = [];
    _this.packageTypeEnum = [];
    _this.packageCategoryEnum = [];
    _this.packageTimeTypeEnum = [];
    return _this;
  }

  Object.defineProperty(WrapperListTab.prototype, "isProductPrivateWrapper", {
    get: function get() {
      return this.customerInfo.is_product_private_wrapper;
    },
    enumerable: false,
    configurable: true
  });

  WrapperListTab.prototype.created = function () {
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: this.onSelectChange
    };
    this.setColumns();
    this.queryList();
    this.queryWarehouseList();
  };

  WrapperListTab.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('耗材类型'),
      dataIndex: 'consumables_type_text',
      filterEmpty: true,
      isCopy: true,
      scopedSlots: {
        customRender: 'consumables_type_text'
      }
    }, {
      title: this.t('包材编码'),
      dataIndex: 'package_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('包材名称'),
      dataIndex: 'package_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('包材归属'),
      dataIndex: 'package_type_text',
      filterEmpty: true
    }, {
      title: this.t('包装类型'),
      dataIndex: 'package_category_text',
      filterEmpty: true
    }, {
      title: this.t('适用仓库（区域）'),
      name: 'warehouse_code',
      dataIndex: 'warehouse_code',
      scopedSlots: {
        customRender: 'warehouse'
      },
      width: 200
    }, {
      title: this.t('尺寸（cm）'),
      name: 'size',
      align: 'right',
      scopedSlots: {
        customRender: 'size'
      }
    }, {
      title: this.t('体积（m³）'),
      name: 'volume',
      dataIndex: 'volume',
      align: 'right'
    }, {
      title: this.t('包材重量（kg）'),
      name: 'weight',
      dataIndex: 'weight',
      align: 'right'
    }, {
      title: this.t('最大承重（kg）'),
      name: 'max_weight',
      dataIndex: 'max_weight',
      align: 'right'
    }, {
      title: this.t('状态'),
      dataIndex: 'status_text',
      scopedSlots: {
        customRender: 'status_text'
      }
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      width: 200,
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      width: 150,
      title: this.t('操作'),
      fixed: 'right',
      name: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  WrapperListTab.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.time_start = '';
      this.searchData.time_end = '';
    }
  };

  WrapperListTab.prototype.initSearchData = function () {
    return {
      status: undefined,
      package_option: 'package_name',
      package_option_value: '',
      time_start: '',
      time_end: '',
      package_category: undefined,
      package_type: undefined,
      warehouse_code: undefined,
      time_type: this.$enum.warehouse.WrapperTimeType.UPDATE_TIME,
      page_index: 1,
      page_size: 20
    };
  };

  WrapperListTab.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = this.rowSelection.selectedRowKeys = selectedRowKeys;
  };

  WrapperListTab.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = null;
            return [4, this.$api.wrapper.queryWrapperList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  WrapperListTab.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  WrapperListTab.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryList();
  };

  WrapperListTab.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryList();
  };

  WrapperListTab.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  WrapperListTab.prototype.handleSearch = function () {
    this.initPage();
    this.queryList();
  };

  WrapperListTab.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryList();
    });
  };

  WrapperListTab.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.package_code_list = this.selectedList;
            }

            return [4, this.$api.wrapper.exportWrapper(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  WrapperListTab.prototype.handleAdd = function () {
    this.rowData.title = this.t('新增包材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = null;
    this.addEditVisible = true;
  };

  WrapperListTab.prototype.handleEdit = function (record) {
    this.rowData.title = this.t('编辑包材');
    this.rowData.warehouseList = this.warehouseList.filter(function (item) {
      return item.is_used;
    });
    this.rowData.data = record;
    this.addEditVisible = true;
  };

  WrapperListTab.prototype.handleCancel = function (packageCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('请确认是否废弃该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_1;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.discardWrapper({
                  package_code_list: [packageCode]
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_1 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  WrapperListTab.prototype.handleLog = function (record) {
    logModalCom({
      parent: this,
      propsData: {
        code: record.package_code
      }
    });
  };

  __decorate([enumData('Wrapper/AuditPageStatusEnum')], WrapperListTab.prototype, "auditPageStatusEnum", void 0);

  __decorate([enumData('Wrapper/PackageOptionEnum')], WrapperListTab.prototype, "packageOptionEnum", void 0);

  __decorate([enumData('Wrapper/PackageTypeEnum')], WrapperListTab.prototype, "packageTypeEnum", void 0);

  __decorate([enumData('Wrapper/PackageCategoryEnum')], WrapperListTab.prototype, "packageCategoryEnum", void 0);

  __decorate([enumData('Wrapper/PackageTimeTypeEnum')], WrapperListTab.prototype, "packageTimeTypeEnum", void 0);

  __decorate([User.State('customerInfo')], WrapperListTab.prototype, "customerInfo", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], WrapperListTab.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([userPrefPageSize('wrapperList')], WrapperListTab.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], WrapperListTab.prototype, "queryList", null);

  WrapperListTab = __decorate([Component({
    components: {
      AddEditModal: AddEditModal
    }
  })], WrapperListTab);
  return WrapperListTab;
}(Vue);

export default WrapperListTab;